// extracted by mini-css-extract-plugin
export var header = "_st-1";
export var maskBottom = "_st-6";
export var maskMiddle = "_st-7";
export var maskTop = "_st-5";
export var root = "_st-0";
export var scrollDownButton = "_st-3";
export var scrollDownButtonHidden = "_st-4";
export var viewport = "_st-2";